import React, { useRef } from 'react';

import styled from 'styled-components';

import StyledTableAdmin from 'common/Table/StyledTableAdmin';

import GroupsTableActions from './GroupsTableActions';
import GroupsTableActive from './GroupsTableActive';
import GroupsTableCommunities from './GroupsTableCommunities';
import GroupsTableGroup from './GroupsTableGroup';
import GroupsTableLastUpdated from './GroupsTableLastUpdated';
import GroupsTableUsers from './GroupsTableUsers';
import { GROUPS_PAGE_SIZE, TABLE_ACTIONS } from '../constants';
import { useGroupsContext } from '../GroupsContext';

const Container = styled.div`
  position: relative;
  display: flex;
  min-height: 0;
`;

const GroupsStyledTable = styled(StyledTableAdmin)`
  &&&&&& {
    .ant-table-pagination.ant-pagination {
      padding-bottom: 12px;
    }
  }
`;

const GroupsTable = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { loading, items, totalItemsCount, filters, setPage } = useGroupsContext();

  const handleChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    const { action } = extra;
    if (action === TABLE_ACTIONS.PAGINATE) {
      setPage(pagination.current);
    }
  };

  const columns = [
    {
      title: 'Group',
      render: (value: any, record: any) => <GroupsTableGroup item={record} />,
    },
    {
      title: 'Active',
      width: 50,
      render: (value: any, record: any) => <GroupsTableActive item={record} />,
    },
    {
      title: 'Users',
      render: (value: any, record: any) => <GroupsTableUsers item={record} />,
    },
    {
      title: 'Communities',
      render: (value: any, record: any) => <GroupsTableCommunities item={record} />,
    },
    {
      title: 'Last Updated',
      render: (value: any, record: any) => <GroupsTableLastUpdated item={record} />,
    },
    {
      title: '',
      width: 100,
      render: (value: any, record: any) => <GroupsTableActions item={record} />,
    },
  ];

  return (
    <Container ref={containerRef}>
      <GroupsStyledTable
        columns={columns}
        dataSource={items}
        rowKey={(record: any) => record.id}
        onChange={handleChange}
        showSorterTooltip={false}
        loading={loading}
        pagination={{
          size: 'small',
          position: ['bottomLeft'],
          showSizeChanger: false,
          current: filters.page,
          pageSize: GROUPS_PAGE_SIZE,
          total: totalItemsCount,
          showTotal: (total, range) => {
            const displayedItems = range[1] - range[0] + 1;
            return (
              <span>
                Showing {displayedItems} of {total} records
              </span>
            );
          },
        }}
      />
    </Container>
  );
};

export default GroupsTable;
